module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "player-layer"
    }
  }, [(_vm.video.video_id) ? _c('iframe', {
    attrs: {
      "width": _vm.width,
      "height": _vm.height,
      "src": '//www.youtube.com/embed/' + _vm.video.video_id,
      "frameborder": "0",
      "allowfullscreen": "false"
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0e9865be!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/videos/VideoItem.vue
// module id = 48
// module chunks = 1 2